import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Clear } from "@mui/icons-material";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import NormalTable from "../../../Component/NormalTable";
import Loading from "../../../Component/Loading";

const SystemView = ({ viewId, handleCloseClick }) => {
  const [loading, setLoading] = useState(false);
  const [comDetail, setComDetail] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    const link = masterAPI["system"].getbyid;
    try {
      const res = await axiosPrivate.get(`${link}/${viewId}`);
      setComDetail(res.data.result);
    } catch (e) {
      setComDetail({});
      console.log(e, "system view");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  const locationColumns = [
    {
      Header: "Location Code",
      accessor: "locationCode",
    },
    {
      Header: "Location Name",
      accessor: "locationName",
    },
  ];

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box sx={{ p: color.masterPageDialogPadding }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: color.AssetTitlesize,
                fontWeight: color.sideFontWeightAsset,
              }}
            >
              {comDetail.systemCode ? `${comDetail.systemCode}-${comDetail.systemName || "--"}` : "--"}
            </Typography>
            <IconButton onClick={handleCancel}>
              <Clear />
            </IconButton>
          </Box>
          <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />

          <Grid container spacing={"1rem"}>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  fontWeight: color.labelFontWeight,
                  mb: color.labelmb,
                  fontSize: color.labelFont,
                  color: color.labelColor,
                }}
              >
                System Name
              </Typography>
              <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {comDetail.systemName || "--"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  fontWeight: color.labelFontWeight,
                  mb: color.labelmb,
                  fontSize: color.labelFont,
                  color: color.labelColor,
                }}
              >
                Parent System
              </Typography>
              <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {comDetail.parentSystemName || "--"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: color.labelFontWeight,
                  mb: color.labelmb,
                  fontSize: color.labelFont,
                  color: color.labelColor,
                }}
              >
                Description
              </Typography>
              <Typography
                sx={{
                  fontSize: color.TabDatafontsize,
                  mb: color.TabDatamarginbottom,
                }}
              >
                {comDetail.description || "--"}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: color.labelFontWeight,
                  mb: color.labelmb,
                  fontSize: color.labelFont,
                  color: color.labelColor,
                }}
              >
                Location
              </Typography>
              <NormalTable columns={locationColumns} data={comDetail.locations || []} />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default SystemView;
